module.exports = __webpack_public_path__ + "static/media/Broadcast_003.2c311db4.png";